import React, { useState } from 'react';
import {OpenSheetMusicDisplay} from 'opensheetmusicdisplay';
import {Pitch} from 'opensheetmusicdisplay';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import ScoreRangeSelector from "./ScoreRangeSelector.js"

import SheetMusicPlayer from "./SheetMusicPlayer.js"

const INPUT_POSITION_OFFSET = 10;

export default class ScoreMouseControl extends React.Component {
	
	state = {
		
	};
	
	scrollBox = this.props.scrollBox;

	lastMouseDownPosition = null;

	setCursorPositionByVerticalItemInfo(verticalItemInfo) {

		if (!verticalItemInfo || verticalItemInfo.isTheLastBeam) {
			return;
		}

		const osmd = this.props.osmd;

		const currentTime = osmd.cursor.Iterator.currentTimeStamp.realValue;
		const targetTime = verticalItemInfo.timestamp.realValue;
		
		// osmd.cursor.resetIterator();
		
		if (currentTime < targetTime) {
			while(osmd.cursor.Iterator.currentTimeStamp.realValue < targetTime) {
				osmd.cursor.next();
			}
		} else if (currentTime > targetTime) {
			while(osmd.cursor.Iterator.currentTimeStamp.realValue > targetTime) {
				osmd.cursor.previous();
			}
		}

		osmd.cursor.update();
	}

	setCursorPositionByTimestamp(timestamp) {
		const osmd = this.props.osmd;

		const currentTime = osmd.cursor.Iterator.currentTimeStamp.realValue;
		const targetTime = timestamp;
		
		// osmd.cursor.resetIterator();
		
		if (currentTime < targetTime) {
			while(osmd.cursor.Iterator.currentTimeStamp.realValue < targetTime && osmd.cursor.Iterator.EndReached) {
				osmd.cursor.next();
			}
		} else if (currentTime > targetTime) {
			while(osmd.cursor.Iterator.currentTimeStamp.realValue > targetTime && !osmd.cursor.Iterator.FrontReached) {
				osmd.cursor.previous();
			}
		}

		osmd.cursor.update();
	}
	
	componentDidMount() {
		// const osmd = this.props.osmd;
		

		this.scrollBox.addEventListener("mousedown", (e)=>{
			this.lastMouseDownPosition = {x: e.clientX + this.scrollBox.scrollLeft, y: e.clientY + this.scrollBox.scrollTop};
		});
		
		this.scrollBox.addEventListener("mouseup", (e)=>{ // here using mouseup instead of mousedown to prevent auto-scrolling when holding the screen
			const osmd = this.props.osmd;
			const osmdExtension = this.props.osmdExtension;

			if (
				this.lastMouseDownPosition != null 
				&& Math.abs(this.lastMouseDownPosition.x - (e.clientX + this.scrollBox.scrollLeft)) < 10
				&& Math.abs(this.lastMouseDownPosition.y - (e.clientY + this.scrollBox.scrollTop)) < 10
			) {	
				const closestVerticalItemInfo = osmdExtension.getClosestVerticalItemInfo(
					osmdExtension.actual2OsmdPosition(e.clientX + this.scrollBox.scrollLeft + INPUT_POSITION_OFFSET),
					osmdExtension.actual2OsmdPosition(e.clientY + this.scrollBox.scrollTop)
				);
				
				if (closestVerticalItemInfo && !closestVerticalItemInfo.isTheLastBeam) {
					// this.setCursorPositionByVerticalItemInfo(closestVerticalItemInfo);

					// var event = new Event("OsmdCursorPositionUpdated");
					// const currentTime = osmd.cursor.Iterator.currentTimeStamp.realValue;
					const targetTime = closestVerticalItemInfo.timestamp.realValue;
					// event.cursor = osmd.cursor;
					// event.timestamp = targetTime;
					// event.originalTime = currentTime;
					// // console.log(event)
					// this.props.onCursorPositionUpdated?.call(this, event);

					SheetMusicPlayer.singleton.seekByTimestamp(targetTime);
				}
			}
			
			this.lastMouseDownPosition = null;
		});
		
		
	}
	
	render() {
		return (
			<Box>
			</Box>
		);
	}
};